import styled from 'styled-components';

export const FormSubtitle = styled.h3`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  margin-top: 20px;
  margin-bottom: 20px;
`;
